import { GenericReactForm, SubmitButton, FormActions, SelectCollectionInput } from 'client/js/util/form_utils';
import {useResource} from 'client/js/util/rest_utils';
import {toast} from 'react-toastify';

const Settings = ({id}) => {
  const { data, component, refetch } = useResource(['virtual_machines', id], `/usercp/virtual_machines/${id}`, {
    keepPreviousData: true,
    refetchInterval: 5000
  });

  if(component) {
    return component;
  }

  const onSuccess = () => {
    toast.success("Einstellungen gespeichert");
    refetch();
  }

  const backupIntervalOptions = [
    [null, 'Deaktiviert'],
    ['daily', 'Täglich (3 Tage Aufbewahrung)'],
    ['weekly', 'Wöchentlich (14 Tage Aufbewahrung)'],
    ['biweekly', 'Zweiwöchentlich (28 Tage Aufbewahrung)'],
    ['monthly', 'Monatlich (60 Tage Aufbewahrung)'],
    ['bimonthly', 'Zweimonatlich (120 Tage Aufbewahrung)']
  ];

  const hint = data.virtual_machine.type == 'vserver'
    ? "Erstellt automatische Backups dieser virtuellen Maschine im gewählten Interval. Die Snapshots werden entsprechend der Aufbewahrungsdauer gehalten. Die automatischen Snapshots eines vServers sind kostenfrei."
    : "Erstellt automatische Backups dieser virtuellen Maschine im gewählten Interval. Die Snapshots werden entsprechend der Aufbewahrungsdauer gehalten, der verwendete Speicherplatz wird nach den Preisen für Snapshots abgerechnet.";

  return (
    <GenericReactForm
      defaults={{backup_interval: data.virtual_machine.backup_interval}}
      namespace={null}
      url={`/usercp/virtual_machines/${id}`}
      verb="PUT"
      onSuccess={onSuccess}
    >
      <SelectCollectionInput
        name="backup_interval"
        label="Automatisches Backup"
        hint={hint}
        options={backupIntervalOptions}
        clearable={true}
      />

      <FormActions>
        <SubmitButton icon="floppy-o" text="Speichern" />
      </FormActions>
    </GenericReactForm>
    );
}

export default Settings;
